import { useTranslation } from "react-i18next";
import { useXlsImporterSettings } from "@tools";
import { TextField } from "@components";
import { Grid, IconButton, Tooltip, useTheme } from "@material-ui/core";
import { ColumnSelector } from "./ColumnSelector";
import { Trash } from "@assets";
import useStyle from "@tools/XlsImporter/components/StepsFactory/steps/Steps.style";

export const AdditionalDescriptionColumn = ({
  index,
  name,
  column,
  colorColumn,
  availableColumns,
  takenColumns,
  ...columnSelectorProps
}) => {
  const { t } = useTranslation();
  const settings = useXlsImporterSettings();
  const theme = useTheme();
  const classes = useStyle();

  const {
    additionalTextColumns,
    setAdditionalTextColumns,
    useMinMax,
  } = settings;

  const handleNameChange = (e) => {
    const nextColumns = [ ...additionalTextColumns ];
    nextColumns[index] = {
      ...nextColumns[index],
      name: e.target.value,
    };
    setAdditionalTextColumns(nextColumns);
  };

  const handleSelect = (e) => {
    const previousColumn = additionalTextColumns[index]?.column;

    if(typeof previousColumn === "number")
      colorColumn([previousColumn], true, true);
    if(typeof e.target.value === "number")
      colorColumn([e.target.value], true, false, theme.props.selections.alt);

    const nextColumns = [ ...additionalTextColumns ];
    nextColumns[index] = {
      ...nextColumns[index],
      column: e.target.value,
    };
    setAdditionalTextColumns(nextColumns);
  };

  const handleRemove = () => {
    const previousColumn = additionalTextColumns[index]?.column;
    if(typeof previousColumn === "number")
      colorColumn([previousColumn], true, true);

    const nextColumns = [ ...additionalTextColumns ];
    nextColumns.splice(index, 1)
    setAdditionalTextColumns(nextColumns);
  };

  return (
    <Grid
      key={index}
      item container
      alignItems="center"
      wrap="nowrap"
      className="rounded w-max min-w-max py-1 px-2"
    >
      <TextField
        id={`text_column_${index + 2}_name`}
        name={`Text column ${index + 2}`}
        value={name}
        onChange={handleNameChange}
        className={classes.fastModeTextColumnName}
        size="small"
      />
      <ColumnSelector
        name={`text_column_${index + 2}`}
        allowClearValue
        availableColumns={availableColumns}
        takenColumns={takenColumns}
        {...columnSelectorProps}
        selectedColumn={column}
        onChange={handleSelect}
        useMinMax={useMinMax}
        size="large"
      />

      <IconButton size="small" className="ml-2" onClick={handleRemove}>
        <Tooltip title={t("views.import.remove_column")}>
          <Trash color="error" />
        </Tooltip>
      </IconButton>
    </Grid>
  )
}